import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Instagram, Mail } from 'lucide-react';
const CHECKOUT_URL = 'https://l.instagram.com/?u=http%3A%2F%2Fwa.me%2F17868671817%3Futm_source%3Dig%26utm_medium%3Dsocial%26utm_content%3Dlink_in_bio%26fbclid%3DPAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnaqJ2Sof8kfKpMO62ETPquQzMk-2f5LDvIZ9MIKBRalOfvG9MYpFuYb5DDDE_aem_l3V7ISs1CoqqMmsUrca1pg&e=AT7ythc19Xwk1ZxDZqn7pj_Ell9adPiCk2-P9fqK616cnbmjzxEBcJ8ATXaG_tA4TMS_dwYUCoaPw3TvwftFSgyJXyIwu7Nn4YUvG2aIPQ';
interface ContactCTAProps {
  onBookClick: () => void;
}
export function ContactCTA({
  onBookClick
}: ContactCTAProps) {
  return <section className="py-20 md:py-32 bg-ivory-dark border-t border-gold/10" data-id="element-39">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-41">
          <h2 className="text-4xl md:text-6xl font-serif text-softBlack mb-6" data-id="element-42">
            Tu piel puede sentirse mejor. <br data-id="element-43" />
            <span className="italic text-gold" data-id="element-44">Agenda tu cita.</span>
          </h2>

          <p className="text-lg text-warmGray mb-10 font-light" data-id="element-45">
            Reserva tu espacio y recibe una recomendación inicial según tu
            objetivo.
          </p>

          <div className="flex flex-col items-center gap-4 mb-12" data-id="element-46">
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="px-10 py-5 bg-gold hover:bg-gold-dark text-white rounded-full text-lg font-medium transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1 inline-block" data-id="element-47">
              Agendar cita
            </a>
            <span className="text-sm text-warmGray/70" data-id="element-48">
              Respuesta en menos de 24 horas.
            </span>
          </div>

          <div className="flex justify-center gap-8" data-id="element-49">
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="p-3 bg-white rounded-full text-warmGray hover:text-gold hover:shadow-md transition-all duration-300" data-id="element-50">
              <MessageCircle size={24} data-id="element-51" />
            </a>
            <a href="#" className="p-3 bg-white rounded-full text-warmGray hover:text-gold hover:shadow-md transition-all duration-300" data-id="element-52">
              <Instagram size={24} data-id="element-53" />
            </a>
            <a href="#" className="p-3 bg-white rounded-full text-warmGray hover:text-gold hover:shadow-md transition-all duration-300" data-id="element-54">
              <Mail size={24} data-id="element-55" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}